//	S T A T E

export interface state___SbDigitalMenuAllergensPage {

	allergens_collection: any[],
	allergens_collection___is_loading: boolean,

}

//	S T A T E   D E F A U L T

export const state___SbDigitalMenuAllergensPage___default: state___SbDigitalMenuAllergensPage = {

	allergens_collection: [],
	allergens_collection___is_loading: true,

}